import { css } from 'styled-components';

const applyResponsiveVdpStyles = (
  theme,
  { mini, expanded },
  additionalCheck: boolean = true
) => {
  const forceMiniVdp = theme.FORCE_MINI_VDP_OMP;

  if (forceMiniVdp && additionalCheck) {
    return mini;
  }
  return css`
    @media only screen and (max-width: ${theme.BP.VDP_MOBILE_WH}) {
      ${mini}
    }
    @media only screen and (min-width: ${theme.BP.VDP_DESKTOP_WL}) {
      ${expanded}
    }
  `;
};

export default applyResponsiveVdpStyles;
